function getLocation() {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(showPosition);
    navigator.geolocation.getCurrentPosition(
      showPosition,
      function(error) {
        if (error.code == 1) {
        //   let stockHolderFront = document.querySelector("product-inventory");
        //       stockHolderFront.innerHTML = "Backorder";
        //       stockHolderFront.setAttribute("data-inventory-level", "backorder");
        //       stockHolderFront.classList.add("responce", "responce-backorder");
        }
      }
    );
	} else {
		alert("Sorry, but Geolocation is not supported by this browser.");
	}
}

function showPosition(position) {
	var lat = position.coords.latitude;
	var long = position.coords.longitude;
	// var url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + long + "&key=AIzaSyANHeRfJzLXJB7dsTGM_GaMRwe5Q7l7rd8";
    var showHolder = document.querySelector(".geoLocation_zip");
	// jQuery.ajax({
	// 	type: "GET",
	// 	url: url,
	// 	dataType: "json",
	// 	success: function (msg) {
	// 		var results = msg.results;
 //          console.log(results);
	// 		var zip = results[6].address_components[0].long_name;
	// 		showHolder.innerHTML += "<span>Your zip code is:</span> " + zip;
	// 	},
	// 	error: function (req, status, error) {
	// 		alert('Sorry, an error occurred.');
	// 	}
	// });




  var point = new google.maps.LatLng(lat, long);
        new google.maps.Geocoder().geocode(
            {'latLng': point},
            function (res, status) {
                var zip = res[0].formatted_address.match(/,\s\w{2}\s(\d{5})/);
                showHolder.innerHTML += "<span>Your zip code is:</span> " + zip[1];
                console.log('here');
              
            //   if (window.location.href.includes('products')) {
            //     let productSku = document.querySelector(".product-sku__value").textContent;
            //         googleApi = 'https://us-central1-turing-audio-424013-c2.cloudfunctions.net/getInStock?sku='+ productSku +'&make=WCI&zip='+ zip[1] +'',
            //         stockHolderFront = document.querySelector("product-inventory");

            //     console.log(googleApi);

            //     if (productSku && zip[1]) {
            //       fetch(googleApi, {
            //           method: 'GET',
            //           headers: {
            //             'Content-Type': 'application/json'
            //           }
            //           }).then(response => {
            //         console.log(response);
            //           if (!response.ok) {
            //             stockHolderFront.innerHTML = "Backorder";
            //             stockHolderFront.setAttribute("data-inventory-level", "backorder");
            //             stockHolderFront.classList.add("responce", "responce-backorder");
            //             console.log("Can't find product by sku.");
            //             throw new Error('Network response was not ok ' + response.statusText);
            //           }
            //           return response.json();
            //         })
            //         .then(data => {
            //           if (data.isInStock) {
            //             stockHolderFront.innerHTML = "In stock";
            //             stockHolderFront.setAttribute("data-inventory-level", "in_stock");
            //             stockHolderFront.classList.add("responce");
            //           } else {
            //             stockHolderFront.setAttribute("data-inventory-level", "backorder");
            //             stockHolderFront.innerHTML = "Backorder";
            //             stockHolderFront.classList.add("responce", "responce-backorder");
            //           }
            //         })
            //         .catch(error => {
            //           console.error('There was a problem with the fetch operation:', error);
            //         });
            //     } else {
            //       stockHolderFront.innerHTML = "Backorder";
            //       stockHolderFront.setAttribute("data-inventory-level", "backorder");
            //       console.log("Can't find product by sku.");
            //       stockHolderFront.classList.add("responce", "responce-backorder");
            //     }
            //   }
              
              console.log(zip.input);
            }
        );
}

// getLocation();